import {Typography} from '@mui/material';
import React from 'react';

import {Drawer} from 'presentation/components/Drawer';
import {translations} from 'presentation/translations-new';
import {FeaturesVisibilityDrawerProps} from './types';

const {featuresDrawer} = translations['pt-br'].privateFlow.profile.dataSharing;
const {understood} = translations['pt-br'].commons;

export function FeaturesVisibilityDrawer({open, onClose}: FeaturesVisibilityDrawerProps) {
	return (
		<Drawer.Root
			open={open}
			onClose={onClose}
			onOpen={() => null}
			customMaxHeight="95%"
			width="420px"
			disableSwipeToOpen>
			<Drawer.Header title={featuresDrawer.title} onClose={onClose} />
			<Drawer.Content>
				<Typography variant="body1">{featuresDrawer.description}</Typography>
			</Drawer.Content>
			<Drawer.Footer
				hideFirstButton
				secondButtonTitle={understood}
				secondButtonOnClick={onClose}
			/>
		</Drawer.Root>
	);
}
